import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import ModalFixed from "../../components/ModalFixed";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import Notification from "../../components/Notification";

import Breadcumbs from "../../components/Breadcumbs";
import { NavLink } from "react-router-dom";

import ConectUs from "../../components/ConectUs";

import TecnologiasOffer from "../../components/TecnologiasOffer";
import { DistanciaNuevosFixed } from "../../components/Pasos";
import TecPagos from "../../components/TecPagos";
import ImageGallery from "../../components/ImageGallery";

function Tecnologias() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                </>
              }
            ></BlockImageCabecera>
            <div className="relative">
              <Notification
                content={
                  <div
                    className="layout8"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                }
              ></Notification>

              <ModalFixed
                title="Proceso de matrícula 📝"
                color="#5854a7"
                content={
                  <>
                    <div className="width400">
                      <ImageGallery
                        gallery={item.field_gallery1}
                      ></ImageGallery>
                    </div>
                  </>
                }
              ></ModalFixed>
            </div>{" "}
            <Breadcumbs
              content={
                <>
                  <NavLink to="/tecnologias">Tecnologias</NavLink>
                </>
              }
            ></Breadcumbs>
            <div
              className="layout8"
              dangerouslySetInnerHTML={{
                __html: item.field_bloque2,
              }}
            />
            <div className="layout8">
              <center>
                <h3>Periodo junio - agosto 2025</h3>
              </center>
            </div>
            <div class="wrapper-academicoffer">
              <div>
                <div class="layout8">
                  <h3>Contabilidad y Asesoría Tributaria</h3>
                  <p>
                    <b>Modalidad:</b> En línea
                  </p>
                  <p>
                    <b>Duración:</b> 2 años
                  </p>

                  <p>
                    <b>Inicio de clases:</b> junio 2025
                  </p>
                  <div class="wrapper-link">
                    <a
                      class="link-offer"
                      href="https://tec.utpl.edu.ec/contabilidad"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ver programa
                      <span class="material-icons">arrow_forward_ios </span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div class="layout8">
                  <h3>Creación Audiovisual Digital</h3>
                  <p>
                    <b>Modalidad:</b> En línea
                  </p>
                  <p>
                    <b>Duración:</b> 2 años
                  </p>
                  <p>
                    <b>Inicio de clases:</b> junio 2025
                  </p>
                  <div class="wrapper-link">
                    <a
                      class="link-offer"
                      href="https://tec.utpl.edu.ec/creacion-audiovisual"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ver programa
                      <span class="material-icons">arrow_forward_ios </span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div class="layout8">
                  <h3>Marketing Turístico Digital</h3>
                  <p>
                    <b>Modalidad:</b> En línea
                  </p>
                  <p>
                    <b>Duración:</b> 2 años
                  </p>
                  <p>
                    <b>Inicio de clases:</b> junio 2025
                  </p>
                  <div class="wrapper-link">
                    <a
                      class="link-offer"
                      href="https://tec.utpl.edu.ec/marketing-turistico"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ver programa
                      <span class="material-icons">arrow_forward_ios </span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div class="layout8">
                  <h3>Modelado BIM para la Industria de la Construcción</h3>
                  <p>
                    <b>Modalidad:</b> En línea
                  </p>
                  <p>
                    <b>Duración:</b> 2 años y medio
                  </p>
                  <p>
                    <b>Inicio de clases:</b> junio 2025
                  </p>
                  <div class="wrapper-link">
                    <a
                      class="link-offer"
                      href="https://tec.utpl.edu.ec/modelado-bim"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ver programa
                      <span class="material-icons">arrow_forward_ios </span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div class="layout8">
                  <h3>Negociación y Ventas</h3>
                  <p>
                    <b>Modalidad:</b> En línea
                  </p>
                  <p>
                    <b>Duración:</b> 2 años
                  </p>
                  <p>
                    <b>Inicio de clases:</b> junio 2025
                  </p>
                  <div class="wrapper-link">
                    <a
                      class="link-offer"
                      href="https://tec.utpl.edu.ec/negociacion"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ver programa
                      <span class="material-icons">arrow_forward_ios </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="layout8 margin">
              <center>
                <h3>Periodo octubre 2025 - febrero 2026</h3>
              </center>
            </div>
            <div class="wrapper-academicoffer">
              <div>
                <div class="layout8">
                  <h3>Comunicación Estratégica y Marketing Digital</h3>
                  <p>
                    <b>Modalidad:</b> En línea
                  </p>
                  <p>
                    <b>Duración:</b> 2 años
                  </p>

                  <p>
                    <b>Inicio de clases:</b> octubre 2025
                  </p>
                  <div class="wrapper-link">
                    <a
                      class="link-offer"
                      href="https://tec.utpl.edu.ec/comunicacion"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ver programa
                      <span class="material-icons">arrow_forward_ios </span>
                    </a>
                  </div>
                </div>
              </div>

              <div>
                <div class="layout8">
                  <h3>Creación Audiovisual Digital</h3>
                  <p>
                    <b>Modalidad:</b> Presencial
                  </p>
                  <p>
                    <b>Duración:</b> 2 años
                  </p>
                  <p>
                    <b>Inicio de clases:</b> octubre 2025
                  </p>
                  <div class="wrapper-link">
                    <a
                      class="link-offer"
                      href="https://tec.utpl.edu.ec/creacion-audiovisual"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ver programa
                      <span class="material-icons">arrow_forward_ios </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="padding">
        <TecPagos></TecPagos>
      </div> 
            <div className="margin">
              <BlockBackgroundImage
                src={item.field_imagen3}
                content={
                  <div
                    className="layout8"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque3,
                    }}
                  />
                }
              ></BlockBackgroundImage>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-tecnologias.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
     
      <ConectUs
        facebook="https://www.facebook.com/utpltec/"
        instagram="https://www.instagram.com/utpltec/"
        tiktok="https://www.tiktok.com/@utpltec"
        x="https://twitter.com/utpl?lang=es"
        youtube="https://www.youtube.com/user/utpl/"
        linkedin="https://www.linkedin.com/company/utpl-tec/"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Tecnologias;
